export interface IDocumentItemTranslation {
  lang: string;
  name: string;
}

export interface IDocumentItemWithTranslations {
  id?: string;
  details?: string | null;
  workName?: string | null;
  productName?: string | null;
  contentTranslations?: IDocumentItemTranslation[] | null;
  productNameTranslations?: IDocumentItemTranslation[] | null;
  childsDocumentItems?: IDocumentItemWithTranslations[] | null;
}

const findDefaultLanguageTranslation = (
  contentTranslations: IDocumentItemTranslation[] | null | undefined,
  defaultLanguage?: string,
): IDocumentItemTranslation | undefined => {
  if (!defaultLanguage || !Array.isArray(contentTranslations)) {
    return undefined;
  }

  return contentTranslations.find(
    (translation) => translation?.lang === defaultLanguage,
  );
};

export const getDocumentItemDetailsByDefaultLanguage = (
  item: IDocumentItemWithTranslations | undefined | null,
  defaultLanguage?: string,
): string => {
  const defaultTranslation = findDefaultLanguageTranslation(
    item?.contentTranslations,
    defaultLanguage,
  );

  return defaultTranslation?.name ?? item?.details ?? "";
};

export const normalizeDocumentItemsDetailsByDefaultLanguage = <
  T extends IDocumentItemWithTranslations,
>(
  documentItems: T[] | null | undefined,
  defaultLanguage?: string,
): T[] | null | undefined => {
  if (!Array.isArray(documentItems) || !defaultLanguage) {
    return documentItems;
  }

  return documentItems.map((item) => {
    const normalizedChildItems = normalizeDocumentItemsDetailsByDefaultLanguage(
      item.childsDocumentItems as T[] | null | undefined,
      defaultLanguage,
    );

    return {
      ...item,
      details: getDocumentItemDetailsByDefaultLanguage(item, defaultLanguage),
      ...(normalizedChildItems !== undefined && {
        childsDocumentItems: normalizedChildItems,
      }),
    };
  });
};
